import { type AclPartnerUserConsentDTO, partnerApi } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const usePartnerConsentCreateUserConsentQuery = () => {
	return useMutation({
		mutationFn: async ({ data = {} }: { data: AclPartnerUserConsentDTO }) =>
			(await partnerApi).postAclPartnerConsentUserConsent(data),
		mutationKey: ['partnerCreateUserConsent']
	});
};
